export function readRuntimeConfig() {
  const sp = new URLSearchParams(window.location.search);
  const qsRealm = sp.get("realm");
  const qsBase  = sp.get("kc_base");

  const lsRealm = localStorage.getItem("realm");
  const lsBase  = localStorage.getItem("kc_base");

  const kcUrl = "keycloak.localhost:9193"

  const realm = qsRealm || lsRealm || "master";
  const keycloakBaseUrl = qsBase || lsBase || `${window.location.protocol}//${kcUrl}`;

  localStorage.setItem("realm", realm);
  localStorage.setItem("kc_base", keycloakBaseUrl);

  return { realm, keycloakBaseUrl };
}